import PermissionGate from '@components/upercut-permissions/PermissionGate';
import OrganizationUserCreate from '@modules/organizationUsers/OrganizationUserCreate';
import OrganizationUserDetail from '@modules/organizationUsers/OrganizationUserDetail';
import OrganizationUserEdit from '@modules/organizationUsers/OrganizationUserEdit';
import OrganizationUserList from '@modules/organizationUsers/OrganizationUserList';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

const OrganizationUserPage = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <PermissionGate permission="organization-users:read">
                        <OrganizationUserList />
                    </PermissionGate>
                }
            />
            <Route
                path="/create"
                element={
                    <PermissionGate permission="organization-users:create">
                        <OrganizationUserCreate />
                    </PermissionGate>
                }
            />
            <Route
                path="/:userId"
                element={
                    <PermissionGate permission="organization-users:read">
                        <OrganizationUserDetail />
                    </PermissionGate>
                }
            />
            <Route
                path="/:userId/edit"
                element={
                    <PermissionGate permission="organization-users:update">
                        <OrganizationUserEdit />
                    </PermissionGate>
                }
            />
            <Route path="*" element={<OrganizationUserFallbackRedirect />} />
        </Routes>
    );
};

const OrganizationUserFallbackRedirect = () => {
    const { id: companyId } = useParams<{ id: string }>();

    if (!companyId) {
        return <Navigate to="/companies" replace />;
    }

    return <Navigate to={`/companies/${companyId}/users`} replace />;
};

export default OrganizationUserPage;
